
import { AddHabitDialog } from "@/components/AddHabitDialog";
import { ProgressIndicator } from "@/components/ProgressIndicator";
import { Habit } from "@/types/habit";

interface AddHabitSectionProps {
  habits: Habit[];
  onAddHabit: (habit: {
    title: string;
    emoji: string;
    totalDays: number;
    reward: string;
    priority: "high" | "medium" | "low";
    dailyTarget?: {
      value: number;
      unit: string;
    };
  }) => void;
}

export const AddHabitSection = ({ habits, onAddHabit }: AddHabitSectionProps) => {
  return (
    <div className="flex flex-col w-full space-y-4">
      {/* Full-width Progress indicator */}
      <ProgressIndicator habits={habits} />
      
      {/* Add New Habit button */}
      <div>
        <AddHabitDialog onAdd={onAddHabit} />
      </div>
    </div>
  );
};
